import React, { Component } from "react";
import PropTypes from "prop-types";

import { drawOnCanvas, renderSVG } from "./EdgeCoordinateV3";
import GenericChartComponent from "../GenericChartComponent";
import { getAxisCanvas, getMouseCanvas } from "../GenericComponent";

import { isNotDefined } from "../utils";

class MouseCoordinateY extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
    this.drawOnCanvas = this.drawOnCanvas.bind(this);
    this.preCanvasDraw = this.preCanvasDraw.bind(this);
    // debug logs removed
  }
  preCanvasDraw(ctx) {
    // Clear the entire mouseCoord canvas before drawing
    // This prevents ghosting of old coordinate labels
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.restore();
  }
  drawOnCanvas(ctx, moreProps) {
    const props = helper(this.props, moreProps);
    if (isNotDefined(props)) return null;
    drawOnCanvas(ctx, props);
  }
  renderSVG(moreProps) {
    const props = helper(this.props, moreProps);
    if (isNotDefined(props)) return null;

    return renderSVG(props);
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        canvasDraw={this.drawOnCanvas}
        preCanvasDraw={this.preCanvasDraw}
        canvasToDraw={getMouseCanvas}
        drawOn={["mousemove", "pan", "drag", "resize"]}
      />
    );
  }
}

MouseCoordinateY.propTypes = {
  displayFormat: PropTypes.func.isRequired,
  yAxisPad: PropTypes.number,
  rectWidth: PropTypes.number,
  rectHeight: PropTypes.number,
  orient: PropTypes.oneOf(["bottom", "top", "left", "right"]),
  at: PropTypes.oneOf(["bottom", "top", "left", "right"]),
  dx: PropTypes.number,
  fill: PropTypes.string,
  opacity: PropTypes.number,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  textFill: PropTypes.string,
};

MouseCoordinateY.defaultProps = {
  yAxisPad: 0,
  rectWidth: 50,
  rectHeight: 20,
  orient: "left",
  at: "left",
  dx: 0,
  arrowWidth: 10,
  fill: "#525252",
  opacity: 1,
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 13,
  textFill: "#FFFFFF",
  strokeOpacity: 1,
  strokeWidth: 1,
};

function helper(props, moreProps) {
  const { mouseXY, show, chartConfig, currentCharts, chartId } = moreProps;
  if (isNotDefined(mouseXY) || !show || !chartConfig) return null;
  // Only render for the chart currently under the cursor (first in currentCharts)
  if (
    Array.isArray(currentCharts) &&
    currentCharts.length > 0 &&
    currentCharts[0] !== chartId
  )
    return null;
  const { yScale } = chartConfig;
  const y = mouseXY[1]; // already chart-relative
  try {
    const val = yScale.invert(y);
    if (val == null || Number.isNaN(val)) return null;
    const coordinate = props.displayFormat ? props.displayFormat(val) : val;
    return getYCoordinate(y, coordinate, props, moreProps, true);
  } catch {
    return null;
  }
}

export function getYCoordinate(y, displayValue, props, moreProps, show) {
  const { width } = moreProps;

  const { orient, at, rectWidth, rectHeight, dx } = props;
  const { fill, opacity, fontFamily, fontSize, textFill, arrowWidth } = props;
  const { stroke, strokeOpacity, strokeWidth } = props;

  const x1 = 0,
    x2 = width;
  const edgeAt = at === "right" ? width : 0;

  const type = "horizontal";
  const hideLine = true;

  const coordinateProps = {
    coordinate: displayValue,
    show: show,
    type,
    orient,
    edgeAt,
    hideLine,
    fill,
    opacity,

    fontFamily,
    fontSize,
    textFill,

    stroke,
    strokeOpacity,
    strokeWidth,

    rectWidth,
    rectHeight,

    arrowWidth,
    dx,
    x1,
    x2,
    y1: y,
    y2: y,
  };
  return coordinateProps;
}

export default MouseCoordinateY;
